;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$timeout", "$stateParams", "glDialog", "siteService", "$uiViewScroll", "glAnalytics"];
  angular.module('app.home').controller('Home', Controller)

  /* @ngInject */
  function Controller(
    $scope,
    $timeout,
    $stateParams,
    glDialog,
    siteService,
    $uiViewScroll,
    glAnalytics
  ) {
    $scope.enquiry = {}

    $scope.scrollToEnquire = scrollToEnquire
    $scope.submitEnquiry = submitEnquiry

    if ($stateParams.enquiry) {
      $timeout(function() {
        scrollToEnquire()
      }, 100)
    }

    function scrollToEnquire() {
      $uiViewScroll('enquire')
      glAnalytics.track('Enquiry', 'view', 'scrollTo')
    }

    function submitEnquiry() {
      if ($scope.enquiryForm.$invalid) {
        return glDialog.alert('', 'Please provide a valid name and email.')
      }

      $scope.sending = true

      siteService.enquire($scope.enquiry).then(onSuccess, onError)

      function onSuccess() {
        $scope.sending = false
        $scope.enquiry = {}
        glDialog.alert('', 'Thank you, we will be in touch soon.')
        glAnalytics.track('Enquiry', 'submit', 'success')
      }

      function onError() {
        $scope.sending = false
        glDialog.alert('', 'There was an issue submitted you enquiry.')
        glAnalytics.track('Enquiry', 'submit', 'failed')
      }
    }
  }
})()
